module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_14-092f5d076ec851e529eb81e8d49c4ad3.jpg";